import type { DonationsState } from '../types';

export const InitState: DonationsState = {
  items: [],
  listStatus: 'idle',
  detail: null,
  detailStatus: 'idle',
};
